import { reportTableTheme } from "../reportTableTheme";
import { decodeHtmlEntities } from "./decodeHtmlEntities";

export function getCompetitorCellBackground(delta: string): string {
  const decoded = decodeHtmlEntities(delta);

  if (decoded.includes("▼") || decoded.includes("↓")) {
    return reportTableTheme.cellBgDown;
  }

  if (decoded.includes("▲") || decoded.includes("↑")) {
    return reportTableTheme.cellBgUp;
  }

  return "#ffffff";
}

export function getCompetitorCellDeltaColor(delta: string, fallbackColor: string): string {
  const decoded = decodeHtmlEntities(delta);

  if (decoded.includes("▲") || decoded.includes("↑")) {
    return reportTableTheme.deltaColorUp;
  }

  return fallbackColor;
}
